<template>
  <div>
    <b-card class="text-center m-4">
      <template v-slot:header>
        <h1>Derzeitiges Mandat</h1>
      </template>
      <b-card-text v-if="mandate === null" >
        Noch kein Mandat eingerichtet
      </b-card-text>
      <div v-if="mandate !== null"
           class="mb-4">
        <table  style="margin-left: auto; margin-right: auto;"
                class="text-left" >
          <tr v-for="(item, key) in mandate">
            <td style="text-align: right;"> {{$t('accounting')[key]}}</td>
            <td style="min-width: 36px; height: 36px; "></td>
            <td>{{item}}</td>
          </tr>
        </table>
        <b-button class="col-12 mt-4"
                  @click="withdraw_mandate()">
          Mandat wiederrufen
        </b-button>
      </div>

    </b-card>

    <b-card v-if="mandate === null"
            class="text-center m-4">
      <template v-slot:header>
        <h1>Erteilung eines SEPA-Basis-Lastschriftmandats</h1>
      </template>
      <b-card-text class="text-left">
        {{$t('accounting.debit_text')}}
      </b-card-text>
      <div class="m-4"></div>
      <b-form-group v-for="(item,key) in account_data"
                    :key="key"
                    label-cols="4"
                    label-cols-lg="2"
                    label-size="md"
                    :label="$t('accounting')[key]"
                    :label-for="'input-'+key">
        <b-form-input :id="'input-'+key"
                      v-model="account_data[key]">
        </b-form-input>
      </b-form-group>
      <b-button class="col-12 mt-4"
                :disabled="!validation"
                @click="create_mandate()">
        Mandat erstellen
      </b-button>
    </b-card>
  </div>
</template>

<script>
  import {ApiRoutesModel} from "@/store/models/layout/api_routes";
  import {ApiRoutesModelMixin} from "@/mixins/api_routes_model__mixin";

  export default {
        name: "luma-accounting-debit",
        mixins:[ApiRoutesModelMixin],
        data:()=>({
            account_data:{
                owner:'',
                iban:'',
                bic:''
            }
        }),
        computed:{
          mandate(){

              const debit = ApiRoutesModel.find('get.billing.debit')
              if(debit.response === null) return null
              if(debit.response['mandate'] === null) return null
              const z = {
                  'created_at':null,
                  'iban':null,
                  'bic':null,
                  'owner':null
              }
              const x = Object.keys(debit.response['mandate'])
              const y = x.map(el=>{
                  z[el] === null ? z[el] = debit.response['mandate'][el] : undefined
              })
              return z
          },

          validation(){
              const name = this.account_data.owner.length < 3 ? false : true
              const iban = this.account_data.iban.length < 8 ? false : true
              const bic = this.account_data.bic.length < 8 ? false : true
              const bools = [name,iban,bic].includes(false)
              return !bools
          }

        },
      methods:{
          create_mandate(){
              const key = 'post.billing.debit'
              const api = ApiRoutesModel.find(key)
              const send = ApiRoutesModel.createAxios(api,this.account_data)
              this.$router.push({name:'accounting-view'})

          },
          withdraw_mandate(){
              const key = 'post.billing.debit.withdraw'
              const api = ApiRoutesModel.find(key)
              const send = ApiRoutesModel.createAxios(api)
              const x = ApiRoutesModel.insert({where:key,data:{response:null}})
              this.$router.push({name:'accounting-view'})

          }
      }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/debit_accounting/luma-accounting-debit.vue